<template>
  <modal ref="modal" contentClasses="px-5 py-4">
    <template v-slot:header>
      <p class="font-weight-semibold text-center">{{ title }}</p>
    </template>
    <p class="text-center">{{ content }}</p>
    <template v-slot:footer>
      <div class="row w-100">
        <div class="col-6 pl-0">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            @click.prevent="onCanceled"
          >
            Annulla
          </button>
        </div>
        <div class="col-6 pr-0">
          <button
            type="submit"
            class="btn btn-primary w-100"
            @click.prevent="onConfirmed"
          >
            Conferma
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import Modal from "components/Modal.vue";

@Component({ components: { Modal } })
export default class ConfirmModal extends Vue {
  @Prop()
  title?: string;

  @Prop()
  content?: string;

  show() {
    const modal = this.$refs.modal as any;
    modal.show();
  }

  hide() {
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  onCanceled() {
    this.hide();
    this.$emit("canceled");
  }

  onConfirmed() {
    this.hide();
    this.$emit("confirmed");
  }
}
</script>

<style scoped></style>
